<template>
    <tiptap-options-menu v-model="optionsModal" icon="settings" :title="$t('config')" save-on-blur>
        <template #activator>
            <app-button
                small
                text="Config"
                icon-size="medium"
                :icon-left="getIcon('settings', 'fad')"
                @click="optionsModal = !optionsModal"
            />
        </template>
        <field-tiptap-config-state
            v-model="state"
            :fields="fields"
            :field-states="fieldStates"
            label="Conditional Field State"
        />
    </tiptap-options-menu>
</template>

<script>
import { findIds } from '@/lib/tiptap';
import TiptapConfigState from '@/models/TiptapConfigState';

export default {
    name: 'TiptapConfigOptions',
    components: {
        TiptapOptionsMenu: () =>
            import(
                /* webpackChunkName: "core" */
                '@/lib/tiptap/components/TiptapOptionsMenu.vue'
            ),
        FieldTiptapConfigState: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/TiptapConfigState'
            )
    },
    props: {
        options: {
            type: Object,
            required: true
        },
        updateAttributes: {
            type: Function,
            required: true
        },
        json: {
            type: [String, Object, Array],
            default: () => []
        }
    },
    data: () => ({
        optionsModal: false
    }),
    computed: {
        fields() {
            return findIds(this.json);
        },
        fieldStates() {
            return ['disabled'];
        },
        validation: {
            get() {
                return this.options.validation;
            },
            set(validation) {
                this.updateAttributes({ validation });
            }
        },
        state: {
            get() {
                return this.options.state.map(item => {
                    return new TiptapConfigState(item);
                });
            },
            set(state = []) {
                state = state
                    .filter(item => !item.$deleted)
                    .filter(item => item.is_valid)
                    .map(item => ({
                        field_id: item.field_id,
                        field_state: item.field_state,
                        condition_field_id: item.condition_field_id,
                        condition_field_value: item.condition_field_value
                    }));

                this.updateAttributes({ state });
            }
        }
    }
};
</script>
